import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { propTypes } from "react-bootstrap/esm/Image";

function TableLoader({ tableHeaders, data }) {
  const [showLoading, setShowLoading] = useState(true);

  React.useEffect(() => {
    let loadingTime = setTimeout(() => {
      setShowLoading(false);
    }, 5000);

    return () => {
      clearTimeout(loadingTime);
    };
  }, []);

  const noDataDisplay = () => {
    return (
      <td colSpan={tableHeaders.length}>
        <FontAwesomeIcon
          icon={"search"}
          alt={"user"}
          aria-hidden="true"
          className="search-table-icon"
        />
        No Data found.
      </td>
    );
  };

  const loadingDisplay = () => {
    return (
      <>
        <tr>
          {/* <td></td> */}
          <td colSpan={tableHeaders.length}>
            <center>
            <div className="row-form center">
            <div className=" spinner-container ">
              <span className=" loading-spinner "></span>
            </div>
            </div>
            </center>
          </td>
          
          {/* {tableHeaders.map((data, index) => {
            return (
              <td key={index} >
                <div className="td-3">
                  <span className=" loading-spinner"></span>
                </div>
              </td>
            );
          })} */}
        </tr>
      </>
    );
  };

  if (data && data.length !== 0) {
    return loadingDisplay();
  } else {
    return (
      <>
        {showLoading && loadingDisplay()}

        {!showLoading && noDataDisplay()}
      </>
    );
  }
}

TableLoader.propTypes = {
  tableHeaders: propTypes.array,
  data: propTypes.any,
};

export default TableLoader;
